<template>
    <div class="img">
      <img src="/static/img/join_us/join-us-banner.png"/>
      <!--<div class="container">-->
        <!--<div>-->
          <!--<p>一些人等着被世界改变-->
<!--而我们已经在-->
<!--改变世界</p>-->
        <!--</div>-->
      <!--</div>-->
    </div>
</template>

<script>
  export default{
    name: 'homeJoinBanner'
  }
</script>

<style scoped>
  div.bg {
    display: flex;
    /*height: 440px;*/
  }

  div.img {
    width: auto;
    height: auto;
    margin: 0;
    padding: 0;
    /*width: 1100px;*/
    /*height: inherit;*/
  }

  div.container {
    padding: 0;
    margin: auto;
    width: auto;
    margin-right: 20%;
  }

  p {
    font-family: Helvetica-Bold, "Helvetica Bold", Helvetica;
    font-weight: 700;
    font-style: normal;
    font-size: 36px;
    color: rgb(255, 255, 255);
    text-align: center;
    white-space: pre-line;
    line-height: 48px;
    padding: 0;
    margin: 0;
  }

  img{
    width: 100%;
    height: 100%;
  }

</style>



// WEBPACK FOOTER //
// HomeJoinBanner.vue?3cf8aeae